import $ from 'jquery'

export class TabNavigation {
  constructor($container) {
    this.$button_more = $container.find('.tab-navigation-see-more')
    this.$container = $container.find('.tab-navigation-container')

    this.$button_more.on('click', 'a', this.handleClickButtonMore.bind(this))
  }

  handleClickButtonMore(e) {
    e.preventDefault()

    this.$container.addClass('show-all')
    this.$button_more.hide()
  }
}

